import styled from '@emotion/styled';
import React from 'react';
import DocumentControl from './DocumentControl';

const DocumentViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface PropTypes {
  documents: string[];
  defaultDocument: string;
  documentUrl: string;
  setDocumentUrl: (docName: string) => void;
  orderId: string;
}

export const DocumentViewer = (props: PropTypes) => {
  return (
    <DocumentViewWrapper>
      <DocumentControl
        documents={props.documents}
        defaultDocument={props.defaultDocument}
        documentUrl={props.documentUrl}
        setDocumentUrl={props.setDocumentUrl}
        orderId={props.orderId}
      />
      {props.documentUrl && (
        <iframe
          title="doc-preview"
          src={`${props.documentUrl}`}
          style={{
            width: '100%',
            height: 768.13,
            border: '1px solid black',
            overflow: 'auto',
          }}
        ></iframe>
      )}
    </DocumentViewWrapper>
  );
};
